export enum ScrollingDirection{
    up,
    down
}